module.exports = __webpack_public_path__ + "static/hazelnut-14905a75057cc5ca8cb9dd1a47bc87f0.svg";